import React from 'react'
import { Spinner, SpinnerProps } from 'react-bootstrap'

interface LoadingProps extends Partial<SpinnerProps> {
	show?: boolean
	small?: boolean
}

export const Loading = (props: LoadingProps) => {
	const { show, small, ...spinnerProps } = props
	if (!show) {
		return null
	}

	return <Spinner className="spinner" animation="border" role="status" size={small ? 'sm' : undefined} {...spinnerProps} />
}
